import { render } from "./Grupos.vue?vue&type=template&id=7866979a&scoped=true"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"

import "./Grupos.vue?vue&type=style&index=0&id=7866979a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7866979a"]])

export default __exports__